import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from   '../../../shared/services/apiService.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { RegexService } from '../../../shared/form-validation/regex.service'
import { Subscription } from 'rxjs';
import { RootService } from '../../../shared/services/root.service'
import { ToastrService } from 'ngx-toastr';
import { BehaviourSubjectService } from '../../../shared/services/behaviour-subject.service'
import { param } from 'jquery';
import { secureStorage } from '../../../shared/services/encryption/secureservice';

@Component({
  selector: 'app-reward-statement',
  templateUrl: './reward-statement.component.html',
  styleUrls: ['./reward-statement.component.scss']
})
export class RewardStatementComponent implements OnInit {
  currentStep: number = 1;
  userData: any;
  loyalityStatementData: any;
  worthBal: any;
  storedReward: any;
  @Output() goBack = new EventEmitter<void>();
  worthstoredValue: string;

  constructor(private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private regexService: RegexService,
    private spinner: NgxSpinnerService,
    private secureService: RootService,
    private behaviourSubject: BehaviourSubjectService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private localStorage: secureStorage,

  ) { }

  productReviewData: any;
  itemsPerPage: any = 10;
  currentPage: any = 1;
  totalItemsTD: any = 0;
  totalItemsBooking: any = 10
  productDetailList: any;
  maximumSize: any = 10;
  totalItemsOffers: any = 0
  height: number = 0;
  width: number = 0;
  isMobile: boolean = false;
  showCongratulationMessage = true;
  environment1 = environment.s3bucket.url;
  showLoader: any = false;
  sub: Subscription = new Subscription();

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      this.currentPage = 1;
      this.userData = this.secureService.getUserData();
      this.storedReward = JSON.parse(this.localStorage.getItem('rewardData'));
    }
      this.route.queryParams.subscribe(params => {
        if (params['step']) {
          this.currentStep = +params['step'];
        }
      })
      this.route.queryParams.subscribe(params => {
        if (params['fromRedeem']) {
          this.currentStep = 4;
          this.showCongratulationMessage = false;
        }
      });
      this.pageChangeLoyalityStatement(this.currentPage)
      if (isPlatformBrowser(this.platformId)) {
      this.worthstoredValue = JSON.parse(this.localStorage.getItem('totalSelected') || 'null');
      }

    
  }
  nextStep() {
      this.currentStep = 4;
  }

  openRewardCenter() {
    this.router.navigate(['/account/reward-center'])
  }

  pageChangeLoyalityStatement(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody =
    {
      "offset": page,
      "limit": 10
    };
    this.getLoyalityStatementData(reqBody);

  }

  getLoyalityStatementData(reqBody : any) {
    const data = {
      mobile_number: this.userData.mobile_number,
      // "action_type":"burn",
      "offset":reqBody.offset,
      "limit":reqBody.limit
    };
    try {
      this.spinner.show();
      this.showLoader = true;
      this.sub.add(
        this.apiService.getloyalityStatement(data).subscribe({
          next: (res) => {
            if (res.success) {
              this.spinner.hide();
              this.showLoader = false;
              this.totalItemsOffers = res?.total_count
              this.loyalityStatementData = res?.data;
              // if(this.loyalityStatementData.status !== 'CANCELED'){
              //   this.behaviourSubject.loyalityUserBalance.next(this.balance);

              // }
            } else {

            }
            this.spinner.hide();

          },
          error: (err) => {
            this.spinner.hide();

          },
          complete: () => {
            this.spinner.hide();
          },
        })
      );
    } catch (error) {

    }
  }

  @Output() goBackto: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


}
